import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import CarditBySendingPostReport from '../component/CarditBySendingPostReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
  getUserType,
} from '../redux/selectors/CarditBySendingPostNumberedSelectors';

export function CarditBySendingPostSignedContainer(props) {
  return (
    <CarditBySendingPostReport
      reportId={ReportDefinitions.CARDIT_BY_SENDING_POST_NUMBERED.id}
      generatedOnDateTime={props.generatedDateTime}
      isLoading={props.isLoading}
      data={props.data}
      columns={props.columns}
      userType={props.userType}
      className="carditBySendingPostReport"
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    userType: getUserType(state),
  };
}

CarditBySendingPostSignedContainer.propTypes = {
  generatedDateTime: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userType: PropTypes.string,
};

export default connect(mapStateToProps)(CarditBySendingPostSignedContainer);
